import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";

function NavBar() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  console.log(currentPath);
  return (
    <div className="navBar-container">
      <BrowserRouter>
        <nav>
          <ul className="Pro-NavBar-Links">
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`nav-link ${currentPath === "/" && "link-glow"}`}
                onClick={() => {
                  window.location.href = "/";
                }}
              >
                Workshop
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/shop"
                className={`nav-link ${currentPath === "/shop" && "link-glow"}`}
                onClick={() => {
                  window.location.href = "/shop";
                }}
              >
                Shop
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/incubator"
                className={`nav-link ${
                  currentPath === "/incubator" && "link-glow"
                }`}
                onClick={() => {
                  window.location.href = "/incubator";
                }}
              >
                Incubator
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`nav-link ${
                  currentPath === "/unassigned" && "link-glow"
                }`}
              >
                Bank
              </Link>
            </li>
            <li className="Pro-NavBar-Links-list1">
              <Link
                to="/"
                className={`nav-link ${
                  currentPath === "/unassigned" && "link-glow"
                }`}
              >
                Redeem
              </Link>
            </li>
          </ul>
        </nav>
      </BrowserRouter>
    </div>
  );
}

export default NavBar;
